import { render, staticRenderFns } from "./policy-information.vue?vue&type=template&id=faee9e78&scoped=true"
import script from "./policy-information.vue?vue&type=script&lang=js"
export * from "./policy-information.vue?vue&type=script&lang=js"
import style0 from "./policy-information.vue?vue&type=style&index=0&id=faee9e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faee9e78",
  null
  
)

export default component.exports